import React from 'react';
import { getResultLabel } from '../../utils/mailto';

// Primary service block — big, prominent
const PrimaryServiceCard = ({ service, language }) => (
  <div className="bg-white rounded-2xl p-8 md:p-12 mb-8 shadow-lg border border-gray-100 scroll-reveal-left">
    <div className="flex items-center gap-4 mb-6">
      <span className="text-5xl">{service.icon}</span>
      <h3 className="text-3xl md:text-4xl font-bold text-gray-900">{service.title}</h3>
    </div>
    <p className="text-xl text-gray-900 font-semibold mb-6 italic">"{service.intro}"</p>
    <div className="bg-blue-50 rounded-xl p-6 mb-6">
      <p className="text-lg font-semibold text-gray-900 mb-4">{service.includesTitle}</p>
      <ul className="space-y-3">
        {service.details.map((detail) => (
          <li key={detail} className="flex items-start gap-3">
            <span className="text-blue-600 text-xl mt-1">✓</span>
            <span className="text-gray-800">{detail}</span>
          </li>
        ))}
      </ul>
    </div>
    {service.result && (
      <div className="bg-green-50 border-l-4 border-green-500 p-6 rounded-lg">
        <p className="text-sm text-gray-600 mb-1">👉 {getResultLabel(language)}</p>
        <p className="text-lg text-green-800 font-semibold">{service.result}</p>
      </div>
    )}
  </div>
);

// Secondary service block — smaller, complementary
const AddonServiceCard = ({ service }) => (
  <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-dashed border-gray-300 max-w-3xl mx-auto scroll-reveal-right">
    <div className="flex items-center gap-3 mb-3">
      <span className="text-3xl">{service.icon}</span>
      <div className="flex-1">
        <div className="flex items-center gap-3 flex-wrap">
          <h3 className="text-xl md:text-2xl font-bold text-gray-900">{service.title}</h3>
          <span className="text-xs font-semibold uppercase tracking-wider px-3 py-1 rounded-full bg-blue-100 text-blue-700">
            {service.addonLabel}
          </span>
        </div>
      </div>
    </div>
    <p className="text-base text-gray-700 mb-5 italic">"{service.intro}"</p>
    <p className="text-sm font-semibold text-gray-900 mb-3">{service.includesTitle}</p>
    <ul className="space-y-2">
      {service.details.map((detail) => (
        <li key={detail} className="flex items-start gap-2 text-sm">
          <span className="text-blue-600 mt-0.5">·</span>
          <span className="text-gray-700">{detail}</span>
        </li>
      ))}
    </ul>
  </div>
);

const ServicesSection = ({ t, language }) => (
  <section id="servicios" className="py-12 bg-gray-50 curtain-section">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12 scroll-reveal">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          {t.services.title} <span className="text-gradient">{t.services.titleHighlight}</span>
        </h2>
      </div>

      <PrimaryServiceCard service={t.services.service1} language={language} />

      <AddonServiceCard service={t.services.service2} />
    </div>
  </section>
);

export default ServicesSection;
